export default __webpack_public_path__ + "fd4e375ac418f5715468e0116ebc99c3.mp3";